//Service page js
$(document).ready(function () {
	if(isElemExist('.page-acimaTermOfServicePage') || isElemExist('.page-acimaPrivacyPolicyPage') || isElemExist('.page-acimaApplicationTermsPage') || isElemExist('.page-acimaEsignPolicyPage')
	|| isElemExist('.page-acimaCaliforniaPolicyPage')
	){
		let url = window.location.href;
		let selectedParamId = url.split('/').pop();
		$('.policies-left-section a.' + selectedParamId).addClass('active');
	}
})